import { createFileRoute } from "@tanstack/react-router";

import { Balance } from "~/components/feature/balance/Balance";

export const Route = createFileRoute("/_app/dashboard/balance")({
  component: RouteComponent,
});

function RouteComponent() {
  return <Balance />;
}
